import { useListStatusesQuery } from 'generated/status.generated';
import type { StatusType } from 'generated/types';

export const useGetStatuses = ({
  model,
  skip = false,
}: {
  model: StatusType;
  skip?: boolean;
}) => {
  const response = useListStatusesQuery({
    variables: {
      input: {
        model,
      },
    },
    skip,
  });
  return { ...response, data: response.data?.listStatuses };
};
